import { render, staticRenderFns } from "./EditManuscrit.vue?vue&type=template&id=743b4948&scoped=true"
import script from "./EditManuscrit.vue?vue&type=script&lang=js"
export * from "./EditManuscrit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "743b4948",
  null
  
)

export default component.exports